module.exports = __webpack_public_path__ + "img/Ripple-1s-800px.8220cf6.gif";